/* */
import disconnected_wav from '@/assets/sounds/disconnected.wav'
import connected_wav from '@/assets/sounds/connected.wav'
import notification_wav from '@/assets/sounds/notification.wav'
import error_wav from '@/assets/sounds/error.wav'
import incorrect_wav from '@/assets/sounds/incorrect.wav'
import login_wav from '@/assets/sounds/login.wav'
import success_wav from '@/assets/sounds/success.wav'

let disconnected = new Audio(disconnected_wav)
let connected = new Audio(connected_wav)
let notification = new Audio(notification_wav)
let error = new Audio(error_wav)
let incorrect = new Audio(incorrect_wav)
let login = new Audio(login_wav)
let success = new Audio(success_wav)

/* 
let path = 'assets/sounds'

let disconnected = new Audio(require(`@/${path}/disconnected.wav`))
let connected = new Audio(require(`@/${path}/connected.wav`))
let notification = new Audio(require(`@/${path}/notification.wav`))
let error = new Audio(require(`@/${path}/error.wav`))
let incorrect = new Audio(require(`@/${path}/incorrect.wav`))
let login = new Audio(require(`@/${path}/login.wav`))
let success = new Audio(require(`@/${path}/success.wav`))

*/

/* */
connected.volume = 0.1
disconnected.volume = 0.1
notification.volume = 0.2
error.volume = 0.2
incorrect.volume = 0.2
login.volume = 0.2
success.volume = 0.2

/* */
export default {
  disconnected,
  connected,
  notification,
  error,
  incorrect,
  login,
  success
}
